/**
 * Payment Request Detail Modal
 * 
 * Displays full payment request JSON data in a modal
 */

import { X } from 'lucide-react';
import type { StoredPayment } from '../../types/mockPaymentApi';

interface PaymentRequestDetailModalProps {
  payment: StoredPayment | null;
  isOpen: boolean;
  onClose: () => void;
}

export function PaymentRequestDetailModal({ 
  payment, 
  isOpen, 
  onClose 
}: PaymentRequestDetailModalProps) {
  if (!isOpen || !payment) return null;

  console.log('Modal payment data:', payment);
  console.log('Payment request:', payment.request);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Payment Request Details</h2>
            <p className="text-sm text-gray-500 mt-1">Payment ID: {payment.id}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close modal"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Metadata Section */}
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <h3 className="text-sm font-semibold text-gray-700 uppercase">Metadata</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-500">Transaction ID:</span>
                <p className="font-mono text-gray-900">{payment.transactionId}</p>
              </div>
              <div>
                <span className="text-gray-500">Status:</span>
                <p className="font-semibold">
                  {payment.status === 'paid' ? (
                    <span className="text-green-600">Paid</span>
                  ) : (
                    <span className="text-yellow-600">Pending</span>
                  )}
                </p>
              </div>
              <div>
                <span className="text-gray-500">Received At:</span>
                <p className="text-gray-900">
                  {new Date(payment.receivedAt).toLocaleString()}
                </p>
              </div>
              {payment.paidAt && (
                <div>
                  <span className="text-gray-500">Paid At:</span>
                  <p className="text-gray-900">
                    {new Date(payment.paidAt).toLocaleString()}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Full Request JSON */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">
              Full Request Data
            </h3>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 overflow-x-auto">
              <pre className="text-sm text-gray-900 font-mono whitespace-pre-wrap break-words">
                {payment.request 
                  ? JSON.stringify(payment.request, null, 2)
                  : 'No request data available'}
              </pre>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

